import { createSlice } from "@reduxjs/toolkit";

const addModalSubliteratureSlice = createSlice({
  name: "addModalSubliterature",
  initialState: {
    isOpen: false,
    error: null,
  },
  reducers: {
    openModal: (state) => {
      state.isOpen = true;
      state.error = null;
    },
    closeModal: (state) => {
      state.isOpen = false;
      state.error = null;
    },
  },
});

export const { openModal, closeModal } = addModalSubliteratureSlice.actions;
export default addModalSubliteratureSlice.reducer;
